import React, { useEffect, useState } from "react";
import { backend } from "../../../../path";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import styled from "styled-components";
import { CiLocationOn } from "react-icons/ci";
import { PiDeviceMobileThin } from "react-icons/pi";
import { CiMail } from "react-icons/ci";
import { GrFacebookOption } from "react-icons/gr";
import { LiaInstagram } from "react-icons/lia";
import { AiFillYoutube } from "react-icons/ai";
import { RiTwitterXLine } from "react-icons/ri";

function FooterMainNew() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const navigate = useNavigate();
  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );

  const fetchData = () => {
    setLoading(true);
    fetch(backend + "getcategorywithsubcategory", {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCategoryMain = (cat) => {
    // setSubcategory(false)
    navigate(`/category/${cat}`);
    // window.location.reload();
  };
  const handleNavigate = () => {
    navigate("/");
    //scroll to top smoothly
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    console.log("footer called");
  }, []);

  return (
    <>
      <div>
        {authenticated?.usertype === 1 ? (
          <Footer>
            <Wrapper>
              <Container>
                <Section>
                  <ImgContainer onClick={handleNavigate}>
                    <img src="/storage/general/ks-logo32.png" alt="" />
                  </ImgContainer>
                  <P>
                    Shop now to Experience <br /> the Authenticity of Kerala!
                  </P>
                </Section>
                <Section className="links">
                  <List>
                    <Head>Company</Head>
                    <Links>
                      <Li className="list">
                        {" "}
                        <a href="/about-us">About us</a>
                      </Li>
                      <Li className="list">
                        {" "}
                        <a href="/contact-us">Contact us</a>
                      </Li>
                      <Li className="list">
                        {" "}
                        <a href="/blog">Blog</a>
                      </Li>
                    </Links>
                  </List>
                  <List>
                    <Head>Categories</Head>
                    <Links>
                      {data &&
                        data.slice(0, -1).map((item, index) => (
                          <Li className="list">
                            {" "}
                            <a href={`/category/${item.category_slug}`}>
                              {item.category_name}
                            </a>
                          </Li>
                        ))}
                    </Links>
                  </List>
                  <List>
                    <Head>Important Links</Head>
                    <Links>
                      <Li className="list">
                        {" "}
                        <Link to="/reset-password">Reset Password</Link>
                      </Li>

                      <Li className="list">
                        {" "}
                        <a href="/policy">Terms & Conditions</a>
                      </Li>
                      <Li className="list">
                        {" "}
                        <a href="/return-refund">Returns & Refund</a>
                      </Li>
                    </Links>
                  </List>
                  <List>
                    <Head>Connect With us</Head>
                    <Links>
                      <Li>
                        {/* <CiLocationOn /> */}

                        <a>
                          38, Thycaud Elankom Nagar, <br /> Thycaud , Trivandrum
                          695014
                        </a>
                      </Li>
                      <Li>
                        {/* <PiDeviceMobileThin /> */}

                        <a>+91 - 7356629493 , 8891196910</a>
                      </Li>
                      <Li>
                        {/* <CiMail /> */}

                        <a>info@keralaspecial.in</a>
                      </Li>
                    </Links>
                    <Socials>
                      <a
                        target="_blank"
                        href="https://www.facebook.com/myKeralaspecial?mibextid=qi2Omg&rdid=kccxW9NpVX3BFzrU&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FXM1oRDDkvagcQKW9%2F%3Fmibextid%3Dqi2Omg"
                      >
                        <GrFacebookOption />
                      </a>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/keralaspecial/"
                      >
                        <LiaInstagram />
                      </a>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/@keralaspecial5256"
                      >
                        <AiFillYoutube />
                      </a>
                      <a
                        target="_blank"
                        href="https://x.com/mykeralaspecial?t=5jaIdWgLfUhVzxywcQto9g"
                      >
                        <RiTwitterXLine />
                      </a>
                    </Socials>
                  </List>
                </Section>
              </Container>
            </Wrapper>
          </Footer>
        ) : authenticated?.usertype === 0 ? (
          <></>
        ) : (
          <Footer>
            <Wrapper>
              <Container>
                <Section>
                  <ImgContainer onClick={handleNavigate}>
                    <img src="/storage/general/ks-logo32.png" alt="" />
                  </ImgContainer>
                  <P>
                    Shop now to Experience <br /> the Authenticity of Kerala!
                  </P>
                </Section>
                <Section className="links">
                  <List>
                    <Head>Company</Head>
                    <Links>
                      <Li className="list">
                        {" "}
                        <Link to="/about-us">About us</Link>
                      </Li>
                      <Li className="list">
                        {" "}
                        <Link to="/contact-us">Contact us</Link>
                      </Li>
                      <Li className="list">
                        {" "}
                        <Link to="/blog">Blog</Link>
                      </Li>
                    </Links>
                  </List>
                  <List>
                    <Head>Categories</Head>
                    <Links>
                      {data &&
                        data.slice(0, -1).map((item, index) => (
                          <Li className="list">
                            {" "}
                            <a href={`/category/${item.category_slug}`}>
                              {item.category_name}
                            </a>
                          </Li>
                        ))}
                    </Links>
                  </List>
                  <List>
                    <Head>Important Links</Head>
                    <Links>
                      <Li className="list">
                        {" "}
                        <Link to="/registration-vendor">
                          Register as vendor
                        </Link>
                      </Li>

                      <Li className="list">
                        {" "}
                        <a href="/policy">Terms & Conditions</a>
                      </Li>
                      <Li className="list">
                        {" "}
                        <a href="/return-refund">Returns & Refund</a>
                      </Li>
                    </Links>
                  </List>
                  <List>
                    <Head>Connect With us</Head>
                    <Links>
                      <Li>
                        {/* <CiLocationOn /> */}

                        <a>
                          38, Thycaud Elankom Nagar, <br /> Thycaud , Trivandrum
                          695014
                        </a>
                      </Li>
                      <Li>
                        {/* <PiDeviceMobileThin /> */}

                        <a>+91 - 7356629493 , 8891196910</a>
                      </Li>
                      <Li>
                        {/* <CiMail /> */}

                        <a>info@keralaspecial.in</a>
                      </Li>
                    </Links>
                    <Socials>
                      <a
                        target="_blank"
                        href="https://www.facebook.com/myKeralaspecial?mibextid=qi2Omg&rdid=kccxW9NpVX3BFzrU&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FXM1oRDDkvagcQKW9%2F%3Fmibextid%3Dqi2Omg"
                      >
                        <GrFacebookOption />
                      </a>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/keralaspecial/"
                      >
                        <LiaInstagram />
                      </a>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/@keralaspecial5256"
                      >
                        <AiFillYoutube />
                      </a>
                      <a
                        target="_blank"
                        href="https://x.com/mykeralaspecial?t=5jaIdWgLfUhVzxywcQto9g"
                      >
                        <RiTwitterXLine />
                      </a>
                    </Socials>
                  </List>
                </Section>
              </Container>
            </Wrapper>
          </Footer>
        )}
      </div>
      <ToastContainer />
    </>
  );
}

export default FooterMainNew;
const Footer = styled.footer`
  padding: 40px 0;
  color: #000 !important;
  border-top: 1px solid rgba(172, 172, 172, 1);
  @media screen and (max-width: 768px) {
    padding: 28px 0;
  }
`;
const Wrapper = styled.div`
  width: 88%;
  margin: 0 auto;
  @media screen and (max-width: 768px) {
    width: 94%;
  }
`;
const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.3fr;
  gap: 30px;

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;
const ImgContainer = styled.div`
  height: 100%;
  width: 192px;
  cursor: pointer;
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    display: block;
  }

  &.payment {
    height: 30px;
    width: 210px;
    margin: 20px 0;
  }
  @media screen and (max-width: 768px) {
    width: 150px;
  }
`;
const Section = styled.div`
  display: grid;
  gap: 20px;
  justify-items: start;

  &.links {
    grid-template-columns: 1fr 1fr 1.2fr 1.2fr;
    gap: 18px;
    @media screen and (max-width: 1000px) {
      grid-template-columns: 1fr 1fr;
      gap: 16px;
    }
    @media screen and (max-width: 500px) {
      grid-template-columns: 1fr;
      gap: 12px;
    }
  }
`;
const P = styled.p`
  padding: 0;
  margin: 0;
  // font-family: "Kantumruy Pro", serif;
  font-family: Jost;
  font-weight: 500;
  font-style: Medium;
  font-size: 26px;
  leading-trim: NONE;
  line-height: 130%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: rgba(0, 0, 0, 0.92);
  @media screen and (max-width: 768px) {
    font-size: 20px;
    line-height: 130%;
  }
`;
const Links = styled.ul`
  padding: 0;
`;
const Li = styled.li`
  // display: grid;
  // grid-template-columns: 0.1fr 1fr;
  gap: 8px;
  align-items: center;
  padding: 10px 0;
  font-family: "Kantumruy Pro", serif;

  a {
    font-family: "Kantumruy Pro", serif;
    color: #000;
    font-size: 14px;

    &:hover {
      transition: all 0.3s ease;
      color: #187837;
      font-weight: 500;
    }
  }
  svg {
    font-size: 18px;
    color: #000;
  }

  &.list {
    grid-template-columns: 1fr;
    padding: 5px 0;
  }
`;
const Head = styled.h4`
  // font-family: "Kantumruy Pro", serif;
  font-weight: 500;
  margin-bottom: 20px;
  font-family: Jost;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 160%;
  letter-spacing: 0%;
  vertical-align: middle;
  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;
const List = styled.div`
  margin-top: 30px;
  @media screen and (max-width: 768px) {
    margin-top: 20px;
  }
`;
const Socials = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 20px 0;
  a {
    flex-shrink: 0;

    background-color: #006d00;
    border-radius: 50%;
    padding: 3px;
  }
  svg {
    color: #fff;
    font-size: 18px;
  }
`;
